import React from 'react';
import styles from './ProblemSection.module.scss';

const BASE = process.env.PUBLIC_URL + '/assets/problem/';

const satellites = [
    { label: 'Hundreds of books', icon: BASE + 'books-icon.svg', top: '6%', left: '58%' },
    { label: 'Fixed curriculum', icon: BASE + 'fixed-curriculum.svg', top: '32%', left: '92%' },
    { label: 'Midnight questions', icon: BASE + 'midnight-icon.svg', top: '70%', left: '92%' },
    { label: 'Missed target', icon: BASE + 'target-icon.svg', top: '94%', left: '58%' },
];

const ProblemSection = () => {
    return (
        <section className={styles.section} aria-label="The Problem">
            <div className={styles.inner}>
                {/* Left — orbit diagram */}
                <div className={styles.diagramWrapper} aria-hidden="true">
                    <div className={styles.orbitRing} />

                    {/* Center circle */}
                    <div className={styles.centerCircle}>
                        <p className={styles.centerTitle}>Traditional Prep<br />is not broken.</p>
                        <p className={styles.centerSub}>But it does feel frustrating</p>
                    </div>

                    {/* Satellite bubbles */}
                    {satellites.map((s) => (
                        <div
                            key={s.label}
                            className={styles.satellite}
                            style={{ top: s.top, left: s.left }}
                        >
                            <img src={s.icon} alt={s.label} className={styles.satIcon} />
                            <span className={styles.satLabel}>{s.label}</span>
                        </div>
                    ))}
                </div>

                {/* Right — text */}
                <div className={styles.textBlock}>
                    <h2 className={styles.heading}>
                        We've tutored 100+ students. We kept seeing the same struggle.
                    </h2>
                    <p className={styles.body}>
                        Let's call her Linh. She's smart and hardworking, but her score is stuck.
                        She has hundreds of books but doesn't know which ones work. She joined
                        classes with fixed curriculum but every student is different. She has
                        questions at midnight but can't ask until next session. She took the test,
                        didn't hit her target, and has no idea what went wrong.
                    </p>
                    <p className={styles.italic}>
                        This is frustrating. Traditional prep isn't broken — it's just not built for
                        how students actually learn.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default ProblemSection;
